// exp5/src/App.js
import React from 'react';
import MainApp from './MainApp.jsx';

export default function App() {
  return <MainApp />;
}
